import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { FaqCategory } from '../../faq/faq.model';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class StaticContentService {
    private faqCategories: BehaviorSubject<Array<FaqCategory>> = new BehaviorSubject<Array<FaqCategory>>([]);

    constructor(private http: HttpClient) {}

    getFaqCategories(): Observable<Array<FaqCategory>> {
        if (this.faqCategories.getValue().length === 0) {
            return this.http.get('/api/static/faq.json').pipe(
                map(res => this.mapResposeBodyToFaqCategories(res).sort(this.sortFaqCategoriesByRank.bind(this))),
                tap(res => this.faqCategories.next(res))
            );
        }
        return this.faqCategories.asObservable();
    }

    private mapResposeBodyToFaqCategories(body: object): Array<FaqCategory> {
        return Object.keys(body).map(key => body[key]);
    }

    private sortFaqCategoriesByRank(category1: FaqCategory, category2: FaqCategory): number {
      return category1.rank > category2.rank ? 1 : -1;
    }

    getChangeLog(changelog: string): Observable<string> {
        console.log('changelog', changelog);
        return this.http.get('/api/static/changelog.xml', {
            responseType : 'text'
        }).pipe(
            map(res => changelog = res)
        );
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/static-content.service.ts